import moment from "moment";

// Promocode validity windows are always expressed in Uzbekistan time. The
// country has no DST, so a fixed offset is exact - no timezone database needed.
export const GMT5_OFFSET = "+05:00";
export const GMT5_LABEL = "GMT+5";

const DATETIME_LOCAL = "YYYY-MM-DDTHH:mm";

/** Absolute instant -> the value a <input type="datetime-local"> should show. */
export const toGmt5Input = (value) =>
  value ? moment(value).utcOffset(GMT5_OFFSET).format(DATETIME_LOCAL) : "";

/** What the admin typed (read as GMT+5 wall time) -> absolute instant. */
export const fromGmt5Input = (value) =>
  value
    ? moment(`${value}${GMT5_OFFSET}`, `${DATETIME_LOCAL}Z`).toISOString()
    : null;

export const formatGmt5 = (value, format = "DD/MM/YYYY HH:mm") =>
  value ? moment(value).utcOffset(GMT5_OFFSET).format(format) : "—";
